// extracted by mini-css-extract-plugin
module.exports = {"TagsContainer":"TagsContainer_TagsContainer__1jG7r","search":"TagsContainer_search__3due6"};